<template>
  <div>
    <v-container fluid class="d-flex" style="min-height: 90vh;" fill-height>
      <v-row align="center" justify="center" class="mx-2">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card
            class="mx-2 my-6 pa-4"
            elevation="6"
            style="border-radius: 16px; background: #f5f7fa;"
          >
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="12" class="d-flex flex-column align-center">
                  <v-img
                    alt="Logo"
                    class="shrink app cursor-pointer"
                    contain
                    src="@/assets/Sundae_Logo.png"
                    transition="scale-transition"
                    :width="$vuetify.breakpoint.smAndDown ? 150 : 220"
                    @click="BackToMainPage()"
                  />
                  <p
                    class="mt-6 text-h5 font-weight-bold"
                    style="color: #3f51b5; text-align: center;"
                  >{{ Username }}</p>

                  <qrcode-vue
                    class="mt-3"
                    :value="QRvalue"
                    :size="$vuetify.breakpoint.smAndDown ? 150 : 200"
                    level="M"
                  />
                  <div class="mt-6 d-flex align-center justify-center" style="flex-wrap: wrap;">
                    <span class="text-subtitle-1 mr-2" style="color: black;">Refresh In:</span>
                    <span
                      class="text-subtitle-1 font-weight-bold"
                      style="color: #4caf50;"
                    >{{ TextTime }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular indeterminate color="indigo" size="70" width="6"></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">Loading, please wait...</span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import QrcodeVue from "qrcode.vue";

export default {
  name: "MyQRParking",
  components: {
    QrcodeVue
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRvalue: "",
      QRsize: 250,
      Username: this.$cookies.get("Username"),
      CreateTime: "",
      TextTime: ""
    };
  },

  async mounted() {
    let self = this;
    await self.getMyQR();
  },

  methods: {
    getMyQR() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}User/MyQR`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.QRvalue = response.data.data.qrData;
            self.CreateTime = response.data.data.createDate;
            self.countdown(10, 0);
          }
          self.LoadingDialog = false;
        })
        .catch(function(error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error
          });
        });
    },

    countdown(minutes, seconds) {
      let self = this;
      var endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? "0" + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          self.getMyQR();
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          self.TextTime =
            (hours ? hours + ":" + twoDigits(mins) : mins) +
            ":" +
            twoDigits(time.getUTCSeconds());
          setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
      }
      endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
      updateTimer();
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    BackToMainPage() {
      let self = this;
      self.$router.push("/MainMenu");
    }
  }
};
</script>
<style scoped>
</style>
